import React, { useEffect, useState } from 'react'

import {
  StyleSheet, TouchableOpacity, View, SafeAreaView, Text, Linking, Platform
} from 'react-native'
import { KeyboardAwareScrollView } from '../Components'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import {
  Title,
  Space,
  ReturnFooter,
  SelectExtended,
  Button,
  CheckBox,
  TextInputExtended,
  Label
} from '@sart/components'

import client from '@sart/client'
import { useContent } from '@sart/content'
import { adaptive, backgroundColors, colors, typography } from '@sart/styles'
import { Camera } from '@sart/icons'
import { testID } from '@sart/utilities'
import * as theme from './signTheme'

export default function SignUpNewCustomerDetails(props) {
  const content = useContent()

  const { navigation, route } = props
  const enteredEmail = route.params?.email
  const customerInfo = route.params?.scannedCustomerInfo
  const [regions, setRegions] = useState([])

  useEffect(() => {
    getRegions()
  }, [])

  async function getRegions() {
    const { values } = await client.getRegionOptionsWithoutPlan()
    const regionsTemp = values.map(value => {
      const transformed = {
        label: value.display_value,
        value: value.key
      }
      return transformed
    })
    regionsTemp.sort(function (a, b) {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0
    });
    setRegions(regionsTemp)
  }

  async function openScanner() {
    navigation.navigate('NcaScanId', { enteredValues: formik.values })
  }

  async function submitCustomerDetails(values, form) {

    values.email = values.email.toLowerCase()
    var dob = new Date(values.year + "-" + values.month + "-" + values.day)
    var minYear = new Date()
    minYear.setFullYear(minYear.getFullYear() - 18)
    var maxYear = new Date()
    maxYear.setFullYear(maxYear.getFullYear() - 150)
    if (values.referralCode) {
      client.setCache({ referralCode: values.referralCode })
    }
    if (dob < maxYear || dob > minYear) {
      form.setFieldError('year', content.forms.dobInvalid)
      form.setFieldError('day', content.forms.dobInvalid)
      form.setFieldError('month', content.forms.dobInvalid)
      return
    }

    client.setCache({
      customerDetails: values,
      registerUser: true
    })

    navigation.navigate('SetPassword', { email: values.email, ncaFlow: true })
  }

  const showRegion = regions && regions.length > 0
  const [helpPoint, setHelpPoint] = useState(false)
  var AgentFormat = new RegExp(/^[a-zA-Z]+$/) //any length only Alpha characters
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: 'MR',
      firstName: '',
      middleName: '',
      lastName: '',
      email: enteredEmail,
      phoneNumber: '',
      dobDay: '',
      dobMonth: '',
      dobYear: '',
      postcode: '',
      address1: '',
      address2: '',
      city: '',
      county: '',
      region: '58',
      validDevice: false,
      termsAndConditions: false,
      privacyPolicy: false,
      ...customerInfo
    },
    validationSchema: Yup.object().shape({
      title: Yup.string().trim().required(content.forms.required),
      firstName: Yup.string().trim().required(" ").test('first-name-check',
        content.register_details.noSpecialCharacters, value => blockSpecialCharacters(value)),
      middleName: Yup.string().trim().test('middle-name-check', content.register_details.noSpecialCharacters, value => blockSpecialCharacters(value)),
      lastName: Yup.string().trim().required(" ").test('last-name-check', content.register_details.noSpecialCharacters, value => blockSpecialCharacters(value)),
      email: Yup.string().required(" ").test('email-check', content.forms.emailInvalidCharacters, function (value) {
        if (value) {
          return value.match(/^([a-z0-9_\-.])+@([a-z0-9_\-.])+\.([a-z])+$/)
        } else {
          return true
        }
      }),
      phoneNumber: Yup.string().trim().required(" ").length(10, content.checkout.numberLength).test('phone number check', content.checkout.numberDigits, function (value) {
        if (value) {
          return value.match(/^\d{10}$/)
        } else {
          return true
        }
      }),
      dobDay: Yup.string().trim().required(formatString(content.forms.isRequired, { label: content.forms.dayLabel })).max(2, content.register_details.dayLength).test('age check 1', content.register_details.invalidDay, function (value) {
        if (value < 1 || value > 31) {
          return false
        }
        if (formik.values.dobMonth) {
          if (formik.values.dobMonth == 2) {
            if (((formik.values.dobYear % 4 == 0) && (formik.values.dobYear % 100 != 0)) || (formik.values.dobYear % 400 == 0)) {
              if (value > 29 || value <= 0) {
                return false
              } else {
                return true
              }
            } else {
              if (value > 28 || value <= 0) {
                return false
              } else {
                return true
              }
            }
          } else if (formik.values.dobMonth == 4 || formik.values.dobMonth == 6 || formik.values.dobMonth == 9 || formik.values.dobMonth == 11) {
            if (value > 30 || value <= 0) {
              return false
            } else {
              return true
            }
          } else if (formik.values.dobMonth == 1 || formik.values.dobMonth == 3 || formik.values.dobMonth == 5 || formik.values.dobMonth == 7 || formik.values.dobMonth == 8 || formik.values.dobMonth == 10 || formik.values.dobMonth == 12) {
            if (value > 31 || value <= 0) {
              return false
            } else {
              return true
            }
          } else {
            return true
          }
        } else {
          return true
        }
      }),
      dobMonth: Yup.string().trim().required(formatString(content.forms.isRequired, { label: content.forms.monthLabel })).max(2, content.register_details.monthLength).test('age check 2', content.register_details.invalidMonth, function (value) {
        if (value > 12 || value <= 0) {
          return false
        } else {
          return true
        }
      }),
      dobYear: Yup.string().trim().required(formatString(content.forms.isRequired, { label: content.forms.yearLabel })).length(4, content.register_details.yearLength).test('age check 3', content.register_details.invalidYear, function (value) {
        if (value && formik.values.dobDay && formik.values.dobMonth) {
          var dob = new Date()
          dob.setFullYear(value)
          dob.setMonth(formik.values.dobMonth - 1)
          dob.setDate(formik.values.dobDay)
          var minYear = new Date()

          minYear.setFullYear(minYear.getFullYear() - 18)

          if (dob > minYear) {
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      }).test('age-check-4', content.register_details.invalidYear2, function (value) {
        if (value && formik.values.dobDay && formik.values.dobMonth) {
          var dob = new Date()
          dob.setFullYear(value)
          dob.setMonth(formik.values.dobMonth - 1)
          dob.setDate(formik.values.dobDay)
          var maxYear = new Date()

          maxYear.setFullYear(maxYear.getFullYear() - 100)
          if (dob < maxYear) {
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      }),
      address1: Yup.string().required(" ").test('address-1-check', content.profile_address.noSpecialCharacters, value => validateAddress(value)),
      address2: Yup.string().test('address-2-check', content.profile_address.noSpecialCharacters, value => validateAddress(value)),
      city: Yup.string().required(" ").test('city-check', content.profile_address.noSpecialCharacters, value => blockSpecialCharacters(value)),
      county: Yup.string().required(" ").test('county-check', content.profile_address.noSpecialCharacters, value => blockSpecialCharacters(value)),
      postcode: Yup.string().trim().required(" ").test('postcode-check', content.profile_address.validPostcode, value => validatePostcode(value)),
    }),
    onSubmit: submitCustomerDetails
  })
  function validateRfc(value) {
    if (!!value && !value.match(/^[A-za-z0-9]{12,13}$/)) {
      return false
    }
    return true
  }

  function validateAgentCode(value) {
    if (AgentFormat.test(value)) {
      //Apply as Agent referral code
      return true
    } else {
      return false
    }
  }

  function blockSpecialCharacters(value) {
    if (value) {
      if (value.match(/^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s'-]+$/)) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }

  function validateAddress(value) {
    if (value) {
      if (value.match(/^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s'-,.]+$/)) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }

  function validatePostcode(value) {
    if (value) {
      return value.match(/^[A-Za-z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/)
    } else {
      return true
    }
  }

  function selectTitle(option) {
    formik.setFieldValue('title', option.value)
  }

  function selectRegion(option) {
    formik.setFieldValue('region', option.value)
  }

  async function openScanner() {
    navigation.navigate('NcaScanId', { enteredValues: formik.values })
  }

  return (
    <SafeAreaView style={styles.container}>
      <KeyboardAwareScrollView style={styles.scrollViewContainer}>
        <Space height={24} />
        <View style={styles.content}>

          <Title {...theme.title}>{content.port.enterDetails}</Title>

          <Space height={styles.spaceHeightTwo.height} />

          <TouchableOpacity style={{ alignSelf: 'center' }} onPress={openScanner}>
            <Camera color={colors.black}/>
          </TouchableOpacity>

          <View style={{ height: '80%' }}>
            <SelectExtended
              label={content.forms.sex}
              value={formik.values.title}
              placeholder={content.forms.sex}
              options={[
                { value: 'MR', label: content.register_details.male },
                // {value:'MRS',label:'Mrs'},
                // {value:'MISS',label:'Miss'},
                { value: 'MS', label: content.register_details.female }]}
              onChange={(option) => selectTitle(option)}
              onOptionChange={option => {
                formik.handleChange('title')(option.value)
              }}
              error={formik.touched.title && formik.errors.title}
              styles={selectStyle}
              labelStyle={styles.labelStyles}
              {...Platform.select({
                // web: { },
                ios: { ...theme.selectIDStyleBackgroundColour },
                android: { ...theme.selectIDStyleBackgroundColour }
              })}
							injectedContent={content}
              {...testID('registerTitle')}
            />
            <TextInputExtended
              label={content.forms.firstNameLabel}
              value={formik.values.firstName}
              placeholder={content.forms.firstNamePlaceholder}
              {...Platform.select({
                web: { autoComplete: "given-name" },
                ios: { textContentType: "givenName" },
                android: { autoCompleteType: "name" }
              })}
              onChangeText={formik.handleChange('firstName')}
              onBlur={formik.handleBlur('firstName')}
              error={formik.touched.firstName && formik.errors.firstName}
              labelStyle={styles.labelStyles}
              style={styles.inputStyle}
              onSubmitEditing={formik.handleSubmit}
              {...Platform.select({
                // web: { },
                ios: { ...theme.textInput },
                android: { ...theme.textInput }
              })}
              {...testID('registerFirstName')}
            />

            <TextInputExtended
              label={content.forms.lastNameLabel}
              keyboardType="default"
              value={formik.values.lastName}
              placeholder={content.forms.lastNamePlaceholder}
              {...Platform.select({
                web: { autoComplete: "family-name" },
                ios: { textContentType: "familyName" },
                android: { autoCompleteType: "name" }
              })}
              onChangeText={formik.handleChange('lastName')}
              onBlur={formik.handleBlur('lastName')}
              error={formik.touched.lastName && formik.errors.lastName}
              labelStyle={styles.labelStyles}
              style={styles.inputStyle}
              onSubmitEditing={formik.handleSubmit}
              {...Platform.select({
                // web: { },
                ios: { ...theme.textInput },
                android: { ...theme.textInput }
              })}
              {...testID('registerLastName')}
              />

            <Space height={24} />

            <Label style={styles.labelStyles}>{content.forms.dobLabel}</Label>

            <View style={styles.inputWrapper}>
              <TextInputExtended
                wrapperStyle={styles.nestedInputs}
                value={formik.values.dobDay}
                maxLength={2}
                placeholder={content.forms.dayPlaceholder}
                keyboardType="number-pad"
                {...Platform.select({
                  web: { autoComplete: "bday-day" },
                  // ios: { textContentType: "bday-day" },
                  //android: { autoCompleteType: "bday-day" }
                })}
                onChangeText={formik.handleChange('dobDay')}
                onBlur={formik.handleBlur('dobDay')}
                error={formik.touched.dobDay && formik.errors.dobDay}
                hideError={false}
                labelStyle={styles.labelStyles}
                style={styles.inputStyle}
                onSubmitEditing={formik.handleSubmit}
                {...Platform.select({
                  // web: { },
                  ios: { ...theme.textInput },
                  android: { ...theme.textInput }
                })} 
                {...testID('registerDOBDay')}/>

              <Space width={8} />

              <TextInputExtended
                wrapperStyle={styles.nestedInputs}
                value={formik.values.dobMonth}
                maxLength={2}
                placeholder={content.forms.monthPlaceholder}
                keyboardType="number-pad"
                {...Platform.select({
                  web: { autoComplete: "bday-month" },
                  // ios: { textContentType: "bday-month" },
                  //android: { autoCompleteType: "bday-month" }
                })}
                onChangeText={formik.handleChange('dobMonth')}
                onBlur={formik.handleBlur('dobMonth')}
                error={formik.touched.dobMonth && formik.errors.dobMonth}
                hideError={false}
                labelStyle={styles.labelStyles}
                style={styles.inputStyle}
                onSubmitEditing={formik.handleSubmit}
                {...Platform.select({
                  // web: { },
                  ios: { ...theme.textInput },
                  android: { ...theme.textInput }
                })} 
                {...testID('registerDOBMonth')}/>

              <Space width={8} />

              <TextInputExtended
                wrapperStyle={styles.nestedInputs}
                value={formik.values.dobYear}
                maxLength={4}
                placeholder={content.forms.yearPlaceholder}
                keyboardType="number-pad"
                {...Platform.select({
                  web: { autoComplete: "bday-year" },
                  // ios: { textContentType: "bday-year" },
                  //android: { autoCompleteType: "bday-year" }
                })}
                onChangeText={formik.handleChange('dobYear')}
                onBlur={formik.handleBlur('dobYear')}
                error={formik.touched.dobYear && formik.errors.dobYear}
                hideError={false}
                labelStyle={styles.labelStyles}
                style={styles.inputStyle}
                onSubmitEditing={formik.handleSubmit}
                {...Platform.select({
                  // web: { },
                  ios: { ...theme.textInput },
                  android: { ...theme.textInput }
                })} 
                {...testID('registerDOBYear')}/>
            </View>

            <Space height={24} />

            <TextInputExtended
              label={content.forms.emailLabel}
              value={formik.values.email}
              placeholder={content.forms.emailPlaceholder}
              keyboardType="email-address"
              {...Platform.select({
                web: { autoComplete: "email" },
                ios: { textContentType: "emailAddress" },
                android: { autoCompleteType: "email" }
              })}
              autoCapitalize="none"
              onChangeText={formik.handleChange('email')}
              onBlur={formik.handleBlur('email')}
              error={formik.touched.email && formik.errors.email}
              labelStyle={styles.labelStyles}
              style={styles.inputStyle}
              onSubmitEditing={formik.handleSubmit}
              {...Platform.select({
                // web: { },
                ios: { ...theme.textInput },
                android: { ...theme.textInput }
              })} 
              {...testID('registerEmail')}/>

            <TextInputExtended
              label={content.forms.phoneNumberLabel}
              value={formik.values.phoneNumber}
              placeholder={content.forms.customerDetailsPhonePlaceholder}
              keyboardType="phone-pad"
              {...Platform.select({
                web: { autoComplete: "tel" },
                ios: { textContentType: "telephoneNumber" },
                android: { autoCompleteType: "tel" }
              })}
              onChangeText={formik.handleChange('phoneNumber')}
              onBlur={formik.handleBlur('phoneNumber')}
              error={formik.touched.phoneNumber && formik.errors.phoneNumber}
              labelStyle={styles.labelStyles}
              style={styles.inputStyle}
              onSubmitEditing={formik.handleSubmit}
              {...Platform.select({
                // web: { },
                ios: { ...theme.textInput },
                android: { ...theme.textInput }
              })}
              {...testID('registerPhone')}
            />

            <Space height={24} />

            <Label style={styles.labelStyles}>{content.forms.addressLabel}</Label>

            <TextInputExtended
              value={formik.values.address1}
              placeholder={content.forms.address1Placeholder}
              {...Platform.select({
                web: { autoComplete: "address-line1" },
                ios: { textContentType: "streetAddressLine1" },
                android: { autoCompleteType: "street-address" }
              })}
              onChangeText={formik.handleChange('address1')}
              onBlur={formik.handleBlur('address1')}
              error={formik.touched.address1 && formik.errors.address1}
              labelStyle={styles.labelStyles}
              style={styles.inputStyle}
              onSubmitEditing={formik.handleSubmit}
              {...Platform.select({
                // web: { },
                ios: { ...theme.textInput },
                android: { ...theme.textInput }
              })}
              {...testID('registerAddress1')}
            />

            <Space height={8} />

            <TextInputExtended
              value={formik.values.address2}
              placeholder={content.forms.address2Placeholder}
              onChangeText={formik.handleChange('address2')}
              onBlur={formik.handleBlur('address2')}
              error={formik.touched.address2 && formik.errors.address2}
              labelStyle={styles.labelStyles}
              style={styles.inputStyle}
              onSubmitEditing={formik.handleSubmit}
              {...Platform.select({
                // web: { },
                ios: { ...theme.textInput },
                android: { ...theme.textInput }
              })}
              {...testID('registerAddress2')}
            />

            <Space height={8} />

            <TextInputExtended
              value={formik.values.city}
              placeholder={content.forms.cityPlaceholder}
              {...Platform.select({
                web: { autoComplete: "address-level2" },
                ios: { textContentType: "addressCity" },
                //android: { autoCompleteType: "address-level2" }
              })}
              onChangeText={formik.handleChange('city')}
              onBlur={formik.handleBlur('city')}
              error={formik.touched.city && formik.errors.city}
              labelStyle={styles.labelStyles}
              style={styles.inputStyle}
              onSubmitEditing={formik.handleSubmit}
              {...Platform.select({
                // web: { },
                ios: { ...theme.textInput },
                android: { ...theme.textInput }
              })}
              {...testID('registerAddressCity')}
            />

            <Space height={8} />

            <View style={styles.inputWrapper}>

              <TextInputExtended
                wrapperStyle={styles.nestedInputs}
                value={formik.values.county}
                placeholder={content.forms.countyPlaceholder}
                {...Platform.select({
                  web: { autoComplete: "address-level11" },
                  ios: { textContentType: "addressState" },
                  //android: { autoCompleteType: "address-level11" }
                })}
                onChangeText={formik.handleChange('county')}
                onBlur={formik.handleBlur('county')}
                error={formik.touched.county && formik.errors.county}
                labelStyle={styles.labelStyles}
                style={styles.inputStyle}
                onSubmitEditing={formik.handleSubmit}
                {...Platform.select({
                  // web: { },
                  ios: { ...theme.textInput },
                  android: { ...theme.textInput }
                })}
                {...testID('registerAddressState')}
              />

              <Space width={8} />

              <TextInputExtended
                wrapperStyle={styles.nestedInputs}
                value={formik.values.postcode}
                placeholder={content.forms.postcodePlaceholder}
                autoCorrect={false}
                {...Platform.select({
                  web: { autoComplete: "postal-code" },
                  ios: { textContentType: "postalCode" },
                  android: { autoCompleteType: "postal-code" }
                })}
                onChangeText={formik.handleChange('postcode')}
                onBlur={formik.handleBlur('postcode')}
                error={formik.touched.postcode && formik.errors.postcode}
                labelStyle={styles.labelStyles}
                style={styles.inputStyle}
                onSubmitEditing={formik.handleSubmit}
                {...Platform.select({
                  // web: { },
                  ios: { ...theme.textInput },
                  android: { ...theme.textInput }
                })}
                {...testID('registerAddressPostcode')}
              />

            </View>

            <Space height={16} />

            <Button
              title={formik.isSubmitting
                ? content.set_password.inProgress
                : content.register_details.action}
              disabled={!formik.dirty || !formik.isValid || formik.isSubmitting}
              onPress={formik.handleSubmit}
              {...styles.inputStyle && {
                style: styles.enabled,
                disabledStyle: styles.disabled
              }
              }
              titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
              disabledTitleStyle={{...typography.extrabold, fontSize: 18, color: colors.srDarkGreen + 45}}
              {...Platform.select({
                web: {},
                ios: { ...theme.button },
                android: { ...theme.button }
              })}
              {...testID('registerSubmit')}
            />
          </View>

          <Space height={12} />
        </View>
      </KeyboardAwareScrollView>
      <ReturnFooter
        cancelStyle={styles.cancelStyle}
        title={content.common.cancel}
        onPress={() => navigation.navigate('SignUpNewCustomerSim')}
      />
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  scrollViewContainer: {
    flex: 1,
    backgroundColor: backgroundColors.srGreen,
  },
  container: {
    flex: 1,
    backgroundColor: backgroundColors.srGreen
  },
  content: {
    //flex: 1,
    ...adaptive.wrapperPadding,
    // justifyContent: 'center',
    // ...adaptive.loginContentHeight
    height: '100%'
  },
  description: {
    textAlign: 'center',
    ...typography.demi,
    color: colors.srGreen
  },
  link: {
    color: colors.clear
  },
  forgottenPassword: {
    color: colors.srGreen
  },
  spaceHeightOne: {
    ...adaptive.spaceHeightLoginScreenOne
  },
  spaceHeightTwo: {
    ...adaptive.spaceHeightLoginScreenTwo
  },
  spaceHeightTop: {
    ...adaptive.spaceHeightLoginScreenTop
  },
  inputStyle: {
    ...typography.demi,
    color: colors.srGreen,
    backgroundColor: colors.white
  },
  labelStyles: {
    ...typography.demi,
    color: colors.white,
  },
  enabled: {
    backgroundColor: colors.srGreyBackground,
  },
  disabled: {
    backgroundColor: colors.srGreyBackground +50
  },
  errorMessage: {
    ...typography.book
  },
  button: {
    ...typography.bold,
    fontSize: 18
  },
  cancelStyle: {
    color: colors.white
  },
  inputWrapper: {
    flexDirection: 'row',
  },
  nestedInputs: {
    flex: 0.5
  },
  label: {
    marginBottom: 8,
  },
  helpPointContainer: {

  },
  helpPointText: {
    ...typography.demi,
    color: Platform.OS === 'web' ? colors.common : colors.white
  },
  helpIcon: {
    justifyContent: 'center'
  },
  checkboxText: {
    ...typography.demi,
    color: Platform.OS == "android" || Platform.OS == "ios" ? colors.clear : colors.srGreen,
    ...adaptive.fontSize,
    ...Platform.select({
      android: {
        paddingTop: 6,
        fontSize: 11
      },
      ios: {
        paddingTop: 6,
        fontSize: 11
      }
    })
  },
  checkboxLink: {
    ...typography.demi,
    color: Platform.OS == "android" || Platform.OS == "ios" ? colors.clear : colors.srGreen,
    textDecorationLine: 'underline',
    ...adaptive.fontSize,
    ...Platform.select({
      android: {
        paddingTop: 6,
        fontSize: 11
      },
      ios: {
        paddingTop: 6,
        fontSize: 11
      }
    })
  },
  checkboxLine: {
    flexDirection: 'row',
    paddingBottom: 8,
  },
  linkFull: {
    ...typography.demi,
    color: Platform.OS == "android" || Platform.OS == "ios" ? colors.clear : colors.srGreen,
    textDecorationLine: 'underline',
    ...adaptive.fontSize,
    ...Platform.select({
      android: {
        paddingTop: 6,
        fontSize: 11
      },
      ios: {
        paddingTop: 6,
        fontSize: 11
      }
    })
  },
  checkbox: {
    transform: [{ scaleX: 1.0 }, { scaleY: 1.0 }],
    padding: 0,
    margin: 0
  }
})

const selectStyle = {
  control: (base) => ({
    ...base,
    ...typography.demi,
  }),
  menu: (base) => ({
    ...base,
    ...typography.demi,
  })
};
